import svg from './row-svg/add-gk.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function AddGkIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default AddGkIcon;
